<template>
    <div id="toolDrawer">
        <div class="drawer_header">
            <img class="header_icon" src="../views/img/robot.png" >
            <div class="header_content">
                <div class="header_line_one">欢迎使用{{ askModel }}提问工具<span class="line_tag">限时免费</span></div>
                <div class="header_line_two">点击选中下面模板即可使用，效果更精准</div>
            </div>
        </div>
        <div :class="['drawer_content_wrapper', site_skin]">
            <div class="content_nav">
                <div @click="changeNav(index)" :class="['nav_item', { 'active': showType == index }]" v-for="(type,index) in appList" :key="index">{{ type.name }}</div>
            </div> 
            <div class="question_lists">
                <div :class="['question_item',{'active':selectData&&selectData.id==app.id}]" v-for="app in appList[showType].sub_list" :key="app.id" @click="selectApplication(app)">
                    <img class="cate_icon" :src="require('./img/application/app_icon_'+app.id+'.png')" />
                    <div class="cate_text">
                        <div class="cate_name">{{ app.name }}</div>
                        <div class="cate_desc">{{ app.desc }}</div>
                    </div>
                    <div class="collection_icon"></div>
                </div>
                <div>{{ copyRight }}</div>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        props:["askModel"],
        data() {
            return {
                selectData:null,
                copyRight:CopyRight||"",
                showType:0,
				appList:[
					{
						name:"精选",
						sub_list:[
                            {name:"小红书创作",id:36,desc:"根据您发布的内容，生成小红书文案"},
                            {name:"日报",id:26,desc:"根据您今日的工作内容，生成日报"},
                            {name:"朋友圈营销文案",id:65,desc:"一键转换，生成适合朋友圈的文案"},
							{name:"周报",id:18,desc:"根据您本周的工作内容，生成周报"},
							{name:"短视频脚本",id:30,desc:"抖音/快手/小红书，短视频文案创作"},
							{name:"旅游计划",id:31,desc:"据您的旅游要求，生成旅游计划"},
							{name:"文本优化",id:32,desc:"根据您的文本，帮您优化和改错"},
							{name:"阅读理解",id:34,desc:"根据您的内容，帮您理解"},
                            {name:"商品卖点",id:66,desc:"自动生成主图和详情页的设计文案"}
						]
					},
                    {
						name:"效率",
						sub_list:[
							{name:"日报",id:26,desc:"根据您今日的工作内容，生成日报"},
							{name:"周报",id:18,desc:"根据您本周的工作内容，生成周报"},
							{name:"E-Mail",id:27,desc:"根据邮件内容，生成完整邮件模版"},
							{name:"SWOT",id:28,desc:"根据您的事件情势，帮您生成SWOT"},
							{name:"OKR",id:29,desc:"分享您未来干的事情，生成OKR"},
							{name:"短视频脚本",id:30,desc:"抖音/快手/小红书，短视频创作"},
							{name:"旅游计划",id:31,desc:"根据你的旅游要求，帮您生成旅游计划"},
							{name:"道歉文",id:33,desc:"根据您犯的错误，给你写一篇道歉文"},
							{name:"阅读理解",id:34,desc:"根据您的内容，帮您理解"},
							{name:"知识百科",id:35,desc:"根据您的问题，回答你"},
							{name:"中英词典",id:63,desc:"根据英语单词，做专业解释和造句"},
							{name:"语法检测",id:64,desc:"精通各国语言，提供需要检查的语句"}
						]
					},
					{
						name:"营销",
						sub_list:[
							{name:"小红书创作",id:36,desc:"根据您发布的内容，生成小红书文案"},
							{name:"小红书标题",id:37,desc:"根据您想发布的内容，生成6个标题"},
							{name:"大众点评/美团",id:38,desc:"探店打卡，生成美团的风格文案"},
							{name:"淘宝/京东/拼多多",id:39,desc:"商品评价，帮您生成购物风格文案"},
							{name:"知乎问答",id:41,desc:"根据您的知乎问题，知乎风格回答你"},
							{name:"朋友圈营销文案",id:65,desc:"一键转换，生成带格式适合朋友圈传播文案"},
							{name:"商品卖点",id:66,desc:"自动生成用于主图和详情页的设计文案"}
						]
					},
                    {
						name:"创作",
						sub_list:[
							// {name:"长文写作",id:60,desc:"用于撰写论文、调研报告等长文章"},
							// {name:"内容改写",id:61,desc:"大幅度改写原文，伪原创必备"},
							// {name:"内容补全",id:62,desc:"根据指定的内容，智能补全内容"},
							{name:"简历优化",id:85,desc:"帮你写简历和优化简历"},
							{name:"编剧剧本",id:86,desc:"根据主题创作出人物故事及对话剧本"},
							{name:"脱口秀",id:84,desc:"根据提供的话题，输出幽默的脱口秀"}
						]
					},
                    {
						name:"图表",
						sub_list:[
                            {name:"饼图",id:68,desc:"根据你的内容，帮你生成可视化饼图"},
                            {name:"柱状图",id:70,desc:"根据你的内容，生成可视化柱状图"},
                            {name:"折线图",id:71,desc:"根据你的内容，生成可视化折线图"},
							{name:"甘特图",id:69,desc:"根据你的内容，生成可视化甘特图"},
							{name:"流程图",id:72,desc:"根据你的内容，生成可视化流程图"},
							{name:"思维导图",id:73,desc:"根据你的内容，生成可视化思维导图"},
							{name:"制作表格",id:74,desc:"根据你的内容，帮你生成可视化表格"}
						]
					},
					{
						name:"专家",
						sub_list:[
                            {name:"佛陀",id:42,desc:"与佛陀对话，学习佛教文化"},
							{name:"中医医生",id:88,desc:"老中医帮你分析病因"},
							{name:"西医医生",id:43,desc:"西医专家帮你分析病因"},
							{name:"诗人",id:44,desc:"输入您的需求，我来帮您写诗"},
							{name:"心理健康顾问",id:89,desc:"提供积极有效的心理健康指导和建议"},
							{name:"法律顾问",id:87,desc:"分析您的处境并提供有效的法律建议"},
							{name:"代码助手",id:67,desc:"专业写代码，检查代码，解释逻辑"}
						]
					},
					{
						name:"娱乐",
						sub_list:[
							{name:"哄女友帮助",id:45,desc:"女朋友生气怎么办？用我帮您分析"},
							{name:"单身狗分析",id:46,desc:"根据情势，分析如何追女/男朋友"},
							{name:"节日祝福 ",id:40,desc:"根据您的过节内容，帮你写祝福语"},
							{name:"Emoji翻译",id:47,desc:"发给我内容，帮您翻译成Emoji表情"},
							{name:"Ai解梦",id:48,desc:"根据您的梦境，分析您的当前运势"},
							{name:"高情商回复",id:49,desc:"根据对方问题，分析如何回复"},
							{name:"甩锅助手",id:50,desc:"根据您的问题，分析如何推卸责任"},
							{name:"夸夸助手",id:51,desc:"根据您的内容，教你如何夸人"},
							{name:"吵架助手",id:52,desc:"根据您的内容，教你如何吵架"},
							{name:"职场小树洞",id:53,desc:"根据您的内容，分析您该如何"}
						]
					},
                    {
						name:"企业",
						sub_list:[
							{name:"商业企划",id:90,desc:"围绕目标，以表格方式写商业企划书"},
							{name:"产品需求文档",id:91,desc:"根据要求撰写PRD产品需求文档"},
							{name:"公司战略决策",id:92,desc:"CEO角度，针对公司困难制定方案"},
							{name:"招聘-岗位助手",id:93,desc:"根据岗位给出所需技能和面试问题"}
						]
					},
                   
				],
                site_skin:''
            }
        },
        created() {
            this.site_skin = SiteSkin
        },
        methods: {
            cancelSelect(){
                // 取消选择
                this.selectData = null
            },
            changeNav(index){
                this.showType = index;
            },
            selectApplication(app){
                if(this.selectData && this.selectData.id == app.id){
                    this.selectData = null
                }else{
                    this.selectData = app
                }
                this.$emit('change',app);
            }
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #toolDrawer{
        width: 320px;
        padding: 0 16px 16px 16px;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .drawer_header{
            display: flex;
            align-items: center;
            height: 60px;
            border-bottom: 1px solid #efeff5;
            flex-shrink: 0;
            .header_icon{
                width: 40px;
                height: 40px;
                border-radius: 20px;
                display: block;
                margin-right: 14px;
                flex-shrink: 0;
            }
            .header_content{
                .header_line_one{
                    color: #333;
                    font-size: 13px;
                    line-height: 23px;
                    .line_tag{
                        padding: 0 7px;
                        color: #f0a020;
                        border-radius: 2px;
                        background-color: #fdf1dd;
                        height: 15px;
                        line-height: 15px;
                        font-size: 11px;
                    }
                }
                .header_line_two{
                    color: #999;
                    font-size: 12px;
                    line-height: 22px;
                }
            }
        }
        .drawer_content_wrapper{
            flex-grow: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            .content_nav{
                flex-shrink: 0;
                line-height: 46px;
                padding-top: 6px;
                display: flex;
                margin-bottom: 24px;
                border-bottom: 1px solid #efeff5;
                justify-content: space-evenly;
                .nav_item{
                    flex-shrink: 0;
                    flex-grow: 0;
                    cursor: pointer;
                    font-size: 13px;
                    position: relative;
                    &.active{
                        color:#18a058;
                        &::after{
                            content: '';
                            display: block;
                            position: absolute;
                            width: 100%;
                            bottom: -1px;
                            left: 0;
                            border-bottom: 1px solid #18a058;
                        }
                    }
                }
            }
            .question_lists{
                padding: 3px 3px 0 3px;
                overflow-y: scroll;
                flex-grow: 1;
                margin-right: -17px;
                .question_item{
                    outline-color: #18a058;
                    outline-offset: 0px;
                    outline-width: 0px;
                    outline-style: solid;
                    background-color: #f6f7f9;
                    border-radius: 3px;
                    overflow: hidden;
                    cursor: pointer;
                    margin-bottom: 10px;
                    word-break: break-all;
                    display: flex;
                    align-items: center;
                    padding: 13px 14px;
                    &.active{
                        outline-width: 2px;
                    }
                    .cate_icon {
                        width: 35px;
                        height: 35px;
                        margin-right: 12px;
                    }
                    .cate_text{
                        flex-grow: 1;
                    }
                    .cate_name {
                        line-height: 20px;
                        font-size: 14px;
                        color: #333;
                    }

                    .cate_desc {
                        margin-top: 5px;
                        font-size: 11px;
                        color: #999;
                        line-height: 18px;
                    }
                }
            }
        }

        .black{
            .content_nav{
                border-bottom: 1px solid #efeff5;
                .nav_item{
                    &.active{
                        color:#333;
                        &::after{
                            border-bottom: 1px solid #333;
                        }
                    }
                }
            }
            .question_lists{
                .question_item{
                    outline-color: #ccc;
                    background-color: #f6f7f9;
                }
            }
        }
    }
</style>